import { render } from "./PrepaCode.vue?vue&type=template&id=08018eb9&scoped=true"
import script from "./PrepaCode.vue?vue&type=script&lang=js"
export * from "./PrepaCode.vue?vue&type=script&lang=js"

import "./PrepaCode.vue?vue&type=style&index=0&id=08018eb9&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08018eb9"]])

export default __exports__